export const siteUserFilterOptions: SiteUserFilter[] = [
  { site_user_name: "John Smith", id: 1 },
  { site_user_name: "Jane Doe", id: 2 },
];
